<ul class="sub-menu-v2 active">
    <app-sidebar2-checkbox
        *ngIf="toggleJobs"
        [statuses]="statuses"
        [settingsFlag]="'NavigationV2Jobs'"
        defaultRoute="/jobs/list"></app-sidebar2-checkbox>

    <li [ngClass]="{ active: orderStatus.length > 0 }">
        <header (click)="getHeaderLink('orders')" class="sub-menu-v2--header" [ngClass]="{ open: toggleOrder }">
            <label>Orders</label>
            <i class="icon-ic-chevron-s1"></i>
        </header>
    </li>

    <app-sidebar2-checkbox
        *ngIf="toggleOrder"
        [statuses]="orderStatus"
        [settingsFlag]="'NavigationV2JobsOrder'"
        defaultRoute="/jobs/orders'"></app-sidebar2-checkbox>

    <li [ngClass]="{ active: invoiceStatus.length > 0 }">
        <header (click)="getHeaderLink('invoices')" class="sub-menu-v2--header" [ngClass]="{ open: toggleInvoice }">
            <label>Invoices</label>
            <i class="icon-ic-chevron-s1"></i>
        </header>
    </li>

    <app-sidebar2-checkbox
        *ngIf="toggleInvoice"
        [statuses]="invoiceStatus"
        [settingsFlag]="'NavigationV2JobsInvoice'"
        defaultRoute="/jobs/invoices"></app-sidebar2-checkbox>

    <li [class.active]="importedBillsSelected" *ngIf="isImportedBillsVisible && (hasSupportedAccountingIntegration$ | async)">
        <header (click)="getHeaderLink('imported-bills')" class="sub-menu-v2--header">
            <label>Imported Bills</label>
        </header>
    </li>

    <li [class.active]="importTimesheetsSelected">
        <header (click)="getHeaderLink('import-timesheets')" class="sub-menu-v2--header">
            <label>Import Timesheets</label>
        </header>
    </li>
</ul>
